export type LatLngPoint = [number, number];

export type HubDemandSplit = {
  pointToHub: number;
  pointToPoint: number;
  hubToHub: number;
};

export const DEFAULT_HUB_DEMAND_SPLIT: HubDemandSplit = {
  pointToHub: 0.5,
  pointToPoint: 0.3,
  hubToHub: 0.2,
};

type TripKind = 'point_to_hub' | 'point_to_point' | 'hub_to_hub';

export function selectTripKind(
  split: HubDemandSplit = DEFAULT_HUB_DEMAND_SPLIT,
  randomValue = Math.random()
): TripKind {
  const clamped = Math.min(1, Math.max(0, randomValue));
  if (clamped < split.pointToHub) return 'point_to_hub';
  if (clamped < split.pointToHub + split.pointToPoint) return 'point_to_point';
  return 'hub_to_hub';
}

export function pickRandomHub(
  hubs: LatLngPoint[],
  randomValue = Math.random()
): LatLngPoint {
  const index = Math.min(hubs.length - 1, Math.floor(Math.max(0, randomValue) * hubs.length));
  return hubs[index];
}
